module.exports = __webpack_public_path__ + "img/ps-5.50cb4b91.jpg";